import React from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { HsmContact, HsmContactBatch } from '../../types';

export interface AssignBatchDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  contact: HsmContact | null;
  batches: HsmContactBatch[];
  selectedBatchId: string;
  setSelectedBatchId: (value: string) => void;
  saving: boolean;
  onSave: () => Promise<void>;
}

export function AssignBatchDialog({
  open,
  onOpenChange,
  contact,
  batches,
  selectedBatchId,
  setSelectedBatchId,
  saving,
  onSave,
}: AssignBatchDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Atribuir Lote</DialogTitle>
          <DialogDescription>
            {contact && (
              <>
                Atribuir contato <strong>{contact.phoneNumber}</strong>
                {contact.name && ` (${contact.name})`} a um lote.
              </>
            )}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="assign-batch">Selecione o Lote</Label>
            <Select
              value={selectedBatchId || 'none'}
              onValueChange={(value: string) =>
                setSelectedBatchId(value === 'none' ? '' : value)
              }
            >
              <SelectTrigger id="assign-batch">
                <SelectValue placeholder="Selecione um lote" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Remover do lote</SelectItem>
                {batches.map((batch) => (
                  <SelectItem key={batch.id} value={batch.id.toString()}>
                    {batch.name} ({batch.contactCount} contatos)
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              disabled={saving}
            >
              Cancelar
            </Button>
            <Button onClick={onSave} disabled={saving}>
              {saving ? 'Salvando...' : 'Salvar'}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
